<template>
  <v-row justify="center">
    <v-dialog
      max-width="700px"
      :value="isVisible"
      persistent
      @keydown.esc="closeModal"
    >
      <v-card style="background-color: #D9D9D9;">
        <v-card-title>
          <span style="color: #54514C;" class="headline">
            {{ label }}
          </span>
        </v-card-title>
        <v-card-text style="color: #54514C;">
          <v-container>
            <v-row>
              <v-col cols="12" sm="12" class="">
                <div class="line-content">
                  <div class="icon">
                    <svg
                      width="50"
                      height="50"
                      viewBox="0 0 120 120"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle cx="60" cy="60" r="60" fill="#8B857D" />
                      <path
                        d="M46.1094 53.5195C46.1094 51.5547 46.8899 49.6704 48.2792 48.2811C49.6685 46.8918 51.5528 46.1113 53.5176 46.1113H77.5893C78.5621 46.1113 79.5254 46.3029 80.4243 46.6752C81.3231 47.0475 82.1397 47.5932 82.8276 48.2811C83.5155 48.969 84.0612 49.7857 84.4335 50.6845C84.8058 51.5833 84.9974 52.5466 84.9974 53.5195V77.5912C84.9974 78.5641 84.8058 79.5274 84.4335 80.4262C84.0612 81.325 83.5155 82.1417 82.8276 82.8296C82.1397 83.5175 81.3231 84.0632 80.4243 84.4355C79.5254 84.8078 78.5621 84.9994 77.5893 84.9994H53.5176C52.5447 84.9994 51.5814 84.8078 50.6826 84.4355C49.7838 84.0632 48.9671 83.5175 48.2792 82.8296C47.5913 82.1417 47.0456 81.325 46.6733 80.4262C46.301 79.5274 46.1094 78.5641 46.1094 77.5912V53.5195Z"
                        stroke="white"
                        stroke-width="6"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M37.8111 73.1575C36.9583 72.673 36.249 71.9714 35.7553 71.1239C35.2615 70.2765 35.0009 69.3134 35 68.3326V40.5554C35 37.4999 37.4999 35 40.5554 35H68.3326C70.4159 35 71.5492 36.0694 72.4992 37.7777"
                        stroke="white"
                        stroke-width="6"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </div>

                  <div>
                    Skopiuj swój unikalny link, za pomocą którego Twoi znajomi
                    będą mogli zarejestrować się na platformie DagaJoga.
                  </div>
                </div>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="12" class="">
                <div class="line-content">
                  <div class="icon">
                    <svg
                      width="50"
                      height="50"
                      viewBox="0 0 120 120"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle cx="60" cy="60" r="60" fill="#8B857D" />
                      <path
                        d="M84.4545 37H34.5455C31.4677 37 29 39.4722 29 42.5556V75.8889C29 77.3623 29.5843 78.7754 30.6242 79.8173C31.6642 80.8591 33.0747 81.4444 34.5455 81.4444H48.4091V87H70.5909V81.4444H84.4545C87.5045 81.4444 89.9723 78.9444 89.9723 75.8889L90 42.5556C90 41.0821 89.4157 39.6691 88.3758 38.6272C87.3358 37.5853 85.9253 37 84.4545 37ZM84.4545 75.8889H34.5455V42.5556H84.4545V75.8889ZM70.5909 59.2222L51.1818 70.3333V48.1111L70.5909 59.2222Z"
                        fill="white"
                      />
                    </svg>
                  </div>

                  <div>
                    Zaproszona osoba musi wykupić subskrypcję dowolnej Platformy
                    DagaJoga (Ogólna lub Początek).
                  </div>
                </div>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="12" class="">
                <div class="line-content">
                  <div class="icon">
                    <svg
                      width="50"
                      height="50"
                      viewBox="0 0 120 120"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle cx="60" cy="60" r="60" fill="#8B857D" />
                      <path
                        d="M42.3245 68.5187C40.844 72.0093 42.1456 76.0834 45.2767 78.205C51.3652 82.346 57.9536 85.6759 64.8783 88.112C68.4331 89.3696 72.4201 87.9684 74.2714 84.6652C79.2783 75.7436 83.6946 66.4937 87.4911 56.9764C87.8781 56.0266 87.9615 54.9769 87.7297 53.9742C86.6821 49.5313 83.3479 36.8386 78.8967 34.5909C74.4455 32.3432 62.4606 37.2893 58.3377 39.1209C57.4098 39.5376 56.635 40.2378 56.1218 41.1237C50.9289 49.9346 46.3197 59.0863 42.3245 68.5187Z"
                        stroke="white"
                        stroke-width="5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M34.1133 54.6987C31.6072 57.5152 31.5547 61.7651 33.8535 64.7577C38.3186 70.5913 43.5137 75.82 49.31 80.3139C52.2834 82.6275 56.5061 82.5747 59.3045 80.0524C66.8693 73.242 73.9776 65.935 80.5828 58.1791C81.2497 57.4077 81.6603 56.4458 81.7572 55.4279C82.167 50.9115 83.014 37.9001 79.5034 34.3694C75.9929 30.8387 63.0675 31.6887 58.5799 32.1036C57.5686 32.2012 56.6129 32.6144 55.8464 33.2856C48.1403 39.9326 40.8801 47.0859 34.1133 54.6987Z"
                        fill="#8B857D"
                        stroke="white"
                        stroke-width="5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M70.9081 39.248C71.9021 39.248 72.8554 39.6455 73.5583 40.3529C74.2612 41.0603 74.656 42.0197 74.656 43.0202C74.656 44.0206 74.2612 44.9801 73.5583 45.6875C72.8554 46.3949 71.9021 46.7923 70.9081 46.7923C69.9141 46.7923 68.9608 46.3949 68.2579 45.6875C67.555 44.9801 67.1602 44.0206 67.1602 43.0202C67.1602 42.0197 67.555 41.0603 68.2579 40.3529C68.9608 39.6455 69.9141 39.248 70.9081 39.248Z"
                        stroke="white"
                        stroke-width="5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M61.6321 57.7747C61.687 56.7638 61.9669 54.9205 60.4427 53.5173M60.4427 53.5173C59.8612 53.0087 59.1839 52.623 58.4513 52.3831C55.3105 51.2691 51.4552 54.9959 54.1837 58.4084C55.6504 60.2442 56.7822 60.8075 56.6723 62.8897C56.5973 64.3533 55.1681 65.8848 53.2842 66.4682C51.6476 66.9762 49.841 66.3048 48.6992 65.0197C47.3024 63.4505 47.4449 61.9718 47.4324 61.3281M60.4427 53.5173L62.1618 51.7871M48.8191 65.2159L47.1875 66.858"
                        stroke="white"
                        stroke-width="5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </div>

                  <div>
                    Za każdą osobę otrzymasz 10 zł rabatu na zakup dowolnej
                    subskrypcji Platformy. Rabaty sumują się!
                  </div>
                </div>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="12" class="">
                <b>Twój link:</b>
                {{ refLink }}
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="#8B857D" text v-on:click="copyLink">
            <font-awesome-icon icon="copy" class="mr-1" />
            Kopiuj link
          </v-btn>
          <v-btn color="#8B857D" text v-on:click="closeModal">
            <font-awesome-icon icon="times" class="mr-1" />
            Zamknij
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { FRONT_URL } from "../../axios";
export default {
  name: "RefLinksInfoModal",
  props: ["isVisible", "label", "userId"],

  data: () => ({}),
  methods: {
    closeModal() {
      this.email = "";
      this.$emit("closeModal");
    },
    copyLink() {
      if (window.isSecureContext && navigator.clipboard) {
        navigator.clipboard.writeText(this.refLink);
        this.$store.dispatch("snackbar/showSnackbar", {
          color: "success",
          message: "Skopiowano link do schowka",
        });
      } else {
        this.$store.dispatch("snackbar/showSnackbar", {
          color: "error",
          message: "Przeglądarka nie obsługuje kopiowania do schowka",
        });
      }

      return;
    },
  },
  computed: {
    refLink() {
      return `${FRONT_URL}/rejestracja?ref=${this.userId}`;
    },
  },
};
</script>
<style type="scss" scoped>
.headline {
  margin-bottom: 2rem;
}
.line-content {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
  margin-bottom: 1rem;
}
.icon {
  min-width: 50px;
  width: 50px;
}
</style>
